import { Chip } from "@mui/material";
import { Datagrid, DateField, FunctionField, List, TextField } from "react-admin";

import { kycAnswerLabel, kycModeLabel, kycStatusLabel } from "./labels";

export function KycList() {
  return (
    <List perPage={25} sort={{ field: "created_at", order: "DESC" }} exporter={false}>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField source="user_phone" label="Телефон" />
        <FunctionField label="Режим" render={(r: { mode: string }) => <Chip size="small" label={kycModeLabel(r.mode)} />} />
        <TextField source="level_name" label="Уровень" />
        <FunctionField label="Статус" render={(r: { review_status: string | null }) => kycStatusLabel(r.review_status)} />
        <FunctionField
          label="Решение"
          render={(r: { review_answer: string | null }) => {
            const l = kycAnswerLabel(r.review_answer);
            if (!l) return null;
            return <Chip size="small" color={r.review_answer === "GREEN" ? "success" : "error"} label={l} />;
          }}
        />
        <TextField source="moderation_comment" label="Комментарий" />
        <DateField source="updated_at" label="Обновлено" showTime />
      </Datagrid>
    </List>
  );
}
